module.exports = __webpack_public_path__ + "static/media/aswani ji_page-0001.cb48d6f6.jpg";